module.exports = __webpack_public_path__ + "static/media/logo.dad08206.png";